/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Money_LabelInputs */

const en_cap_money_label = /** @type {(inputs: Cap_Money_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make money`)
};

const lv_cap_money_label = /** @type {(inputs: Cap_Money_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelniet vairāk`)
};

/**
* | output |
* | --- |
* | "Make money" |
*
* @param {Cap_Money_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_money_label = /** @type {((inputs?: Cap_Money_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Money_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_money_label(inputs)
	return en_cap_money_label(inputs)
});